<div class="container">
    <!-- Header Section -->
    <div class="header">
      <h1>India's No. 1 Online Bus Ticket Booking Site</h1>
    </div>
  
    <!-- Search Bar Section -->
    <div class="search-bar">
      <div class="search-item">
        <label>From</label>
        <div class="input-field">
          <i class="material-icons">directions_bus</i>
          <input type="text" placeholder="Indira Gandhi International">
        </div>
      </div>
      <div class="swap-icon">
        <i class="material-icons">swap_horiz</i>
      </div>
      <div class="search-item">
        <label>To</label>
        <div class="input-field">
          <i class="material-icons">directions_bus</i>
          <input type="text" placeholder="Mumbai International Airport">
        </div>
      </div>
      <div class="search-item">
        <label>Date</label>
        <div class="input-field">
          <i class="material-icons">calendar_today</i>
          <input type="date" value="2025-01-27">
        </div>
      </div>
      <button class="search-button">Search Buses</button>
    </div>
  
    <!-- Promo Section -->
    <div class="promo-section">
      <h2>Apno ko, Sapno ko Kareeb Laaye.</h2>
      <div class="bus-illustration">
        <img src="assets/bus-image.png" alt="Bus">
      </div>
    </div>
  </div>
  